export const NO_DATA_MIN_HEIGHT_MOBILE = "200px";
export const NO_DATA_MIN_HEIGHT_DESKTOP = "300px";

const HEADER_HEIGHT = "68px";
const GAME_LIST_PAGE_HEADER_HEIGHT = "156px";

export const GAME_LIST_MIN_HEIGHT = `calc(100vh - ${HEADER_HEIGHT} - ${GAME_LIST_PAGE_HEADER_HEIGHT})`;
